<template>
	<section>

		<!--Upcoming Events-->
		<!--Basic Box-->
		<div class="basic-box cabinet__basic-box">
			<div class="basic-box__title">Ближайшие записи</div>

			<visit-item v-for="event in visits" :key="event._id" :event="event"></visit-item>

			<div v-if="!visits.length">У Вас еще нет событий</div>

			<!-- Button -->
			<div class="basic-box__btns text_center" v-show="visits.length < pagination.total">
				<button class="basic-box__btn btn_light-blue" @click="loadMore">
					Показать больше
					<i class="basic-box__icon_light basic-box__icon_arrow_down icon ion-chevron-down"></i>
				</button>
			</div>
			<!-- Button End -->

		</div>
		<!--Basic Box-->
		<!--Upcoming Events End-->

	</section>
</template>

<script>
	import VisitItem from '@/components/VisitItem.vue';

	export default {
		name: 'Visits',
		components: {VisitItem},
		computed: {
			clinicID() {
				return this.$route.params.clinic;
			},
		},
		mounted() {
			this.$event.connect('updateEvents', () => this.getVisits(this.count));
			this.getVisits();
		},
		data() {
			return {
				visits: [],
				pagination: {},
				count: 10,
			}
		},
		methods: {
			getVisits(count = 10) {
				return this.$store.dispatch('agenda/list', {clinic_id: this.clinicID, sort: 'desc', per_page: count})
					.then(visits => {
						this.pagination = visits;
						return this.visits = visits.data;
					});
			},
			loadMore() {
				this.count += 10;
				this.getVisits(this.count);
			},
		},
		beforeDestroy() {

		},
	}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Visits.vue?1beac2b0